import React from "react";
import "./FeatureItem.css";

const FeatureItem = ({ image, heading, subheading, text, reverse, bgClass }) => {
    return (
        <div className={`feature-item ${reverse ? "reverse" : ""} ${bgClass || ""}`}>
            <div className="feature-text">
                <h2 dangerouslySetInnerHTML={{ __html: heading }} />
                <h4>{subheading}</h4>
                <p>{text}</p>
            </div>

            <div className="feature-image">
                <img src={image} alt={heading.replace(/<[^>]+>/g, "")} />
            </div>
        </div>
    );
};

export default FeatureItem;
